import React from "react";
import { Link } from "react-router-dom";
import "./singleRecipiePage.css";
const SingleRecipiePageRight = (props) => {
  return (
    // headingcss="blackHeading"
    //       pcss="blackP"
    <>
      <img src={props.currrentImg} alt="img2" />
      <div className="blackComponentSingleRecipieRight">
        <div className={props.headingcss} style={props.decorate}>
          {props.heading}
        </div>
        <p className={props.pcss}>
          {props.text}
        </p>
        <div className="flex">
        {props.link1 ? (
            <Link
              to={`${props.link1}`}
              className="removeLinkDecoration"
            >
              <button className={props.linkClass}>{props.link1Text}</button>
            </Link>
          ) : (
            ""
          )}
          {props.link2 ? (
            <Link
              to={`${props.link2}`}
              className="removeLinkDecoration"
              target="_blank"
            >
              <button className={props.linkClass}>Buy Now</button>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
      {props.sideImg ? (
        <div className="sideImgRight">
          <img src={props.sideImg} className="sideimage" alt="sideImg" />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default SingleRecipiePageRight;
